import { LocaleKeys } from '../../../../locale/translation-types'

export enum AsthmaSeverityEnum {
  MILD = 'MILD',
  SEVERE = 'SEVERE'
}

export const asthmaSeverityMapping: Record<AsthmaSeverityEnum, LocaleKeys> = {
  [AsthmaSeverityEnum.MILD]: 'asthma.severity.enum.MILD',
  [AsthmaSeverityEnum.SEVERE]: 'asthma.severity.enum.SEVERE'
}
